import React from 'react';
// import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

const DatePicker = ({ setDate }) => {

    const handleEvent = (event, picker) => {
        const daterange = {
            start: picker.startDate.format('YYYY-MM-D'),
            end: picker.endDate.format('YYYY-MM-D')
        }

        setDate(daterange);
    }

    return (
        <DateRangePicker onApply={ handleEvent } opens="left">
            <button className="date-btn date-open"><i className="fas fa-calendar-alt"></i> Filter</button>
        </DateRangePicker>
    );
}
 
export default DatePicker;
// class DatePicker extends React.Component {

//     constructor(props) {
//         super(props);
//     }

//     handleEvent = (event, picker) => {
//         const daterange = {
//             start: picker.startDate.format('YYYY-MM-D'),
//             end: picker.endDate.format('YYYY-MM-D')
//         }

//         this.props.setDate(daterange);
//     }

//     render() {
//         return (
//             <span>
//                 <DateRangePicker onApply={ this.handleEvent } opens="left">
//                     <button className="date-btn date-open"><i className="fas fa-calendar-alt"></i> Date Filter</button>
//                 </DateRangePicker>
//             </span>
//         )
//     }
// }

// export default DatePicker
